/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whole_Wacky_Poodle_ForgiveInputs */

const fr_whole_wacky_poodle_forgive = /** @type {(inputs: Whole_Wacky_Poodle_ForgiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En passant par cette attribution, l'utilisateur aura accès au programme.<br /> Attention cela
				ne déclenche en aucun cas un paiement`)
};

/**

* @param {Whole_Wacky_Poodle_ForgiveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const whole_wacky_poodle_forgive = /** @type {((inputs?: Whole_Wacky_Poodle_ForgiveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whole_Wacky_Poodle_ForgiveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_whole_wacky_poodle_forgive(inputs)
});